if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      getOptionValuesForChange(target) {
        const selected = this.selectedOptionValues;
        const position = Number(target.dataset.optionPosition);
        if (!Number.isInteger(position) || position < 1 || position > selected.length) return selected;
        const source = this.querySelector('[data-variant-combinations]');
        if (!source) return selected.slice(0, position);
        let combinations;
        try {
          combinations = JSON.parse(source.textContent);
        } catch {
          return selected.slice(0, position);
        }
        const { options, variants, count } = combinations;
        if (!Array.isArray(options) || !Array.isArray(variants) || variants.length !== count) {
          return selected.slice(0, position);
        }
        const values = selected.map((id, index) => options[index]?.find((value) => value.id === id)?.name);
        const matching = variants.filter((variant) =>
          values.slice(0, position).every((value, index) => variant.options[index] === value)
        );
        const variant = matching.find((item) => item.options.every((value, index) => value === values[index]))
          || matching.find((item) => item.available)
          || matching[0];
        if (!variant) return selected.slice(0, position);
        const resolved = variant.options.map((name, index) => options[index]?.find((value) => value.name === name)?.id);
        return resolved.every(Boolean) ? resolved : selected.slice(0, position);
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[data-option-value-id]:checked, fieldset input[data-option-value-id]:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.getOptionValuesForChange(target),
            },
          });
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.hasAttribute('selected'))
            ?.removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
